import { render, staticRenderFns } from "./InfinityPointsHeader.vue?vue&type=template&id=07f4803c&scoped=true"
import script from "./InfinityPointsHeader.vue?vue&type=script&lang=js"
export * from "./InfinityPointsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4803c",
  null
  
)

export default component.exports